<template>
  <CommonValuationEmailManager type="post" department="rs" title="Sales Post Valuation Email Manager" />
</template>
<script>
import CommonValuationEmailManager from './CommonValuationEmailManager'
export default {
  components: { CommonValuationEmailManager },
  name: 'PostValuationEmailManager'
}
</script>
